import isMobileLayout from '../utils/isMobileLayout';
import './VehicleDetail.css';
import { useEffect, useRef, useState } from 'react';

function VehicleDetail({
  vehiculoSeleccionado,
  setVehiculoSeleccionado,
  onClose
}) {
const [isMobile, setIsMobile] = useState(
  () =>
    typeof window !== 'undefined' &&
    isMobileLayout()
);
const dragRef = useRef(null);
const dragDataRef = useRef({ offsetX: 0, offsetY: 0 });
const [position, setPosition] = useState({ x: 320, y: 138 });
const [dragging, setDragging] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(isMobileLayout());
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const vehicleDetailKey = String(
  vehiculoSeleccionado?.imei ||
  vehiculoSeleccionado?.uniqueId ||
  vehiculoSeleccionado?.id ||
  vehiculoSeleccionado?.name ||
  ''
);

useEffect(() => {
  if (!isMobile || !vehicleDetailKey) {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(
      'maccez:vehicle-detail-open'
    )
  );
}, [
  isMobile,
  vehicleDetailKey
]);
useEffect(() => {
  if (!dragging) return;

  const moverVentana = (e) => {
    const nueva = limitarPosicion(
      e.clientX - dragDataRef.current.offsetX,
      e.clientY - dragDataRef.current.offsetY
    );

    setPosition(nueva);
  };

  const soltarVentana = () => {
    setDragging(false);
  };

  window.addEventListener('pointermove', moverVentana);
  window.addEventListener('pointerup', soltarVentana);
  window.addEventListener('blur', soltarVentana);

  return () => {
    window.removeEventListener('pointermove', moverVentana);
    window.removeEventListener('pointerup', soltarVentana);
    window.removeEventListener('blur', soltarVentana);
  };
}, [dragging, isMobile]);
  if (!vehiculoSeleccionado) return null;

  const vehicleState = getVehicleState(vehiculoSeleccionado);
  const licenseStatus = vehiculoSeleccionado.license_status;
  const licenseInactive = vehiculoSeleccionado.licenseValid === false ||
    ['expired', 'unlicensed', 'suspended'].includes(licenseStatus);
  const expiry = vehiculoSeleccionado.license_expires_at;

  const imei =
    vehiculoSeleccionado.imei ||
    vehiculoSeleccionado.uniqueId ||
    vehiculoSeleccionado.deviceUniqueId ||
    vehiculoSeleccionado.deviceId ||
    '—';

    const entrada1 =
  vehiculoSeleccionado.din1Status ||
  vehiculoSeleccionado.entrada1Status ||
  formatInputValue(
    vehiculoSeleccionado.din1 ??
    vehiculoSeleccionado.entrada1 ??
    vehiculoSeleccionado.input1 ??
    vehiculoSeleccionado.in1
  );

const entrada2 =
  vehiculoSeleccionado.din2Status ||
  vehiculoSeleccionado.entrada2Status ||
  formatInputValue(
    vehiculoSeleccionado.din2 ??
    vehiculoSeleccionado.entrada2 ??
    vehiculoSeleccionado.input2 ??
    vehiculoSeleccionado.in2
  );

const entrada3 =
  vehiculoSeleccionado.din3Status ||
  vehiculoSeleccionado.entrada3Status ||
  formatInputValue(
    vehiculoSeleccionado.din3 ??
    vehiculoSeleccionado.entrada3 ??
    vehiculoSeleccionado.input3 ??
    vehiculoSeleccionado.in3
  );

const salida1 =
  vehiculoSeleccionado.dout1Status ||
  vehiculoSeleccionado.salida1Status ||
  formatInputValue(
    vehiculoSeleccionado.dout1 ??
    vehiculoSeleccionado.salida1 ??
    vehiculoSeleccionado.output1 ??
    vehiculoSeleccionado.out1
  );

const salida2 =
  vehiculoSeleccionado.dout2Status ||
  vehiculoSeleccionado.salida2Status ||
  formatInputValue(
    vehiculoSeleccionado.dout2 ??
    vehiculoSeleccionado.salida2 ??
    vehiculoSeleccionado.output2 ??
    vehiculoSeleccionado.out2
  );

const salida3 =
  vehiculoSeleccionado.dout3Status ||
  vehiculoSeleccionado.salida3Status ||
  formatInputValue(
    vehiculoSeleccionado.dout3 ??
    vehiculoSeleccionado.salida3 ??
    vehiculoSeleccionado.output3 ??
    vehiculoSeleccionado.out3
  );
const limitarPosicion = (x, y) => {
  const width = dragRef.current?.offsetWidth || 300;
  const height = dragRef.current?.offsetHeight || 240;
  const margen = 12;

  return {
    x: Math.max(margen, Math.min(window.innerWidth - width - margen, x)),
    y: Math.max(70, Math.min(window.innerHeight - height - margen, y))
  };
};

const iniciarArrastre = (e) => {
  if (isMobile) return;
  if (!dragRef.current) return;

  e.preventDefault();

  const rect = dragRef.current.getBoundingClientRect();

  dragDataRef.current = {
    offsetX: e.clientX - rect.left,
    offsetY: e.clientY - rect.top
  };

  setDragging(true);

  try {
    e.currentTarget.setPointerCapture?.(e.pointerId);
  } catch (_) {}
};


  const licenseLabel = licenseStatus === 'unlicensed'
    ? 'Sin licencia'
    : licenseStatus === 'suspended'
      ? 'Licencia suspendida'
      : licenseInactive
        ? 'Licencia vencida'
        : licenseStatus === 'expiring'
          ? 'Próxima a vencer'
          : 'Licencia activa';
  const ownerEmail = vehiculoSeleccionado.owner_email ||
    vehiculoSeleccionado.user_email || 'Sin correo registrado';
  const plate = String(vehiculoSeleccionado.plate || '').trim();

  return (
    <aside
      ref={dragRef}
      className={`maccez-vehicle-detail ${isMobile ? 'maccez-vehicle-detail--mobile' : 'maccez-vehicle-detail--desktop'}`}
      style={isMobile ? undefined : {
        left: position.x,
        top: position.y,
        cursor: dragging ? 'grabbing' : 'default'
      }}
      aria-label={`Detalle de ${vehiculoSeleccionado.name || 'vehículo'}`}
    >
      <header
        className="maccez-vehicle-detail__header"
        onPointerDown={iniciarArrastre}
        style={isMobile ? undefined : { cursor: dragging ? 'grabbing' : 'grab' }}
      >
        <div className="maccez-vehicle-detail__heading">
          <span className="maccez-vehicle-detail__eyebrow">DETALLE DEL ACTIVO</span>
          <h2>{vehiculoSeleccionado.name || 'Activo'}</h2>
          <div className="maccez-vehicle-detail__identity">
            <strong className="maccez-vehicle-detail__plate">
              {plate || 'Sin placa'}
            </strong>
            <span className="maccez-vehicle-detail__state">
              <i style={{ background: vehicleState.color }} />
              {vehicleState.label}
            </span>
          </div>
        </div>
        <button
          type="button"
          className="maccez-vehicle-detail__close"
          onPointerDown={(event) => event.stopPropagation()}
          onClick={(event) => {
            event.stopPropagation();
            if (onClose) onClose();
            else setVehiculoSeleccionado(null);
          }}
          aria-label="Cerrar detalle del vehículo"
        >×</button>
      </header>

      <div className="maccez-vehicle-detail__account">
        <span>Correo de la cuenta</span>
        <strong title={ownerEmail}>{ownerEmail}</strong>
      </div>

      <div className="maccez-vehicle-detail__dates">
        <div>
          <span>En línea desde</span>
          <strong>{formatDetailDate(vehiculoSeleccionado.first_online_at, 'Sin primer reporte')}</strong>
        </div>
        <div className={licenseInactive ? 'maccez-vehicle-detail__license--inactive' : ''}>
          <span>{licenseLabel}</span>
          <strong>{expiry ? `Vence ${formatDetailDate(expiry)}` : 'Sin fecha de vencimiento'}</strong>
        </div>
      </div>

      {!licenseInactive && (
        <div className="maccez-vehicle-detail__grid">
          <Item label="Modelo" value={vehiculoSeleccionado.model || vehiculoSeleccionado.protocol || '—'} />
          <Item label="IMEI" value={imei} />
          <Item label="Velocidad" value={`${vehiculoSeleccionado.speed || 0} km/h`} />
          <Item label="Ignición" value={formatBoolean(vehiculoSeleccionado.ignition, 'Encendida', 'Apagada')} />
          <Item label="Movimiento" value={formatBoolean(vehiculoSeleccionado.motion, 'En movimiento', 'Detenido')} />
          <Item label="Batería vehículo" value={formatVoltage(vehiculoSeleccionado.power)} />
          <Item label="Batería GPS" value={formatBatteryPercent(vehiculoSeleccionado.battery)} />
          <Item label="Conexión" value={formatGsm(vehiculoSeleccionado.gsm)} />
          <Item label="GPS" value={formatGpsSignal(vehiculoSeleccionado.sat)} />
          <Item label="Kilometraje" value={formatKilometraje(vehiculoSeleccionado.odometer)} />
          <Item label={vehiculoSeleccionado.input1Name || 'Ignición'} value={entrada1} />
          <Item label={vehiculoSeleccionado.input2Name || 'Puertas'} value={entrada2} />
          <Item label={vehiculoSeleccionado.input3Name || 'Entrada 3'} value={entrada3} />
          <Item label={vehiculoSeleccionado.output1Name || 'Protección del motor'} value={salida1} />
          <Item label={vehiculoSeleccionado.output2Name || 'Claxon'} value={salida2} />
          <Item label={vehiculoSeleccionado.output3Name || 'Apertura de puertas'} value={salida3} />
        </div>
      )}
    </aside>
  );
}

function Item({ label, value }) {
  return (
    <div className="maccez-vehicle-detail__item">
      <span>{label}</span>
      <strong title={String(value ?? '')}>{value}</strong>
    </div>
  );
}

function formatDetailDate(value, empty = 'Sin fecha') {
  if (!value) return empty;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return empty;
  return date.toLocaleDateString('es-CO', {
    timeZone: 'America/Bogota', day: 'numeric', month: 'short', year: 'numeric'
  });
}

function getVehicleState(vehicle) {
  const licenseStatus =
    vehicle.license_status ||
    vehicle.licenseStatus ||
    null;

  const connectionStatus =
    vehicle.connectionStatus ||
    vehicle.status ||
    'OFFLINE';

  const speed = Number(vehicle.speed || 0);

  const isMoving =
    speed > 0 ||
    vehicle.motion === 'EN MOVIMIENTO' ||
    vehicle.motion === true;

  if (
    licenseStatus === 'unlicensed' ||
    vehicle.licenseValid === false ||
    licenseStatus === 'expired' ||
    licenseStatus === 'blocked' ||
    licenseStatus === 'suspended'
  ) {
    return {
      label: licenseStatus === 'unlicensed' ? 'Sin licencia' :
        licenseStatus === 'suspended' ? 'Licencia suspendida' : 'Licencia vencida',
      color: '#ef4444'
    };
  }
if (connectionStatus === 'SIN_REPORTE') {
  return {
    label: 'Sin reporte',
    color: '#64748b'
  };
}

  if (connectionStatus === 'STALE') {
    return {
      label: 'Señal antigua',
      color: '#f59e0b'
    };
  }

if (connectionStatus === 'OFFLINE') {
  const ignitionOff =
    vehicle.ignition === false ||
    vehicle.ignition === 0 ||
    vehicle.ignition === '0' ||
    vehicle.ignition === 'false' ||
    vehicle.ignition === 'OFF' ||
    vehicle.ignition === 'APAGADO';

  const rawSecondsAgo = vehicle.secondsAgo;

  const secondsAgo =
    rawSecondsAgo === null ||
    rawSecondsAgo === undefined ||
    rawSecondsAgo === ''
      ? null
      : Number(rawSecondsAgo);

  const hasValidSecondsAgo =
    Number.isFinite(secondsAgo) && secondsAgo >= 0;

  if (
    ignitionOff &&
    hasValidSecondsAgo &&
   secondsAgo <= 2 * 60 * 60
  ) {
    return {
      label: 'En reposo',
      color: '#3b82f6'
    };
  }

  if (ignitionOff) {
    return {
      label: 'Sin comunicación',
      color: '#94a3b8'
    };
  }

  return {
    label: 'Sin señal',
    color: '#ef4444'
  };
}
  if (connectionStatus === 'ONLINE' && isMoving) {
    return {
      label: 'En movimiento',
      color: '#22c55e'
    };
  }

  return {
    label: 'En línea',
    color: '#3b82f6'
  };
}

function formatBoolean(value, trueText, falseText) {
  if (
    value === true ||
    value === 1 ||
    value === '1' ||
    value === 'true' ||
    value === 'ON' ||
    value === 'ENCENDIDO' ||
    value === 'EN MOVIMIENTO'
  ) {
    return trueText;
  }

  return falseText;
}

function formatInputValue(value) {
  if (
    value === true ||
    value === 1 ||
    value === '1' ||
    value === 'true' ||
    value === 'ON'
  ) {
    return 'ON';
  }

  return 'OFF';
}

function formatVoltage(value) {
  const voltage = Number(value);

  if (Number.isNaN(voltage) || voltage <= 0) return 'Sin datos';

  return `${voltage.toFixed(1)} V`;
}

function formatBatteryPercent(value) {
  const voltage = Number(value);

  if (Number.isNaN(voltage) || voltage <= 0) return 'Sin datos';

  const min = 3.3;
  const max = 4.2;

  const percent = Math.max(
    0,
    Math.min(100, Math.round(((voltage - min) / (max - min)) * 100))
  );

  return `${percent}%`;
}

function formatGsm(value) {
  const gsm = Number(value);

  if (Number.isNaN(gsm)) return 'Sin datos';
  if (gsm >= 5) return 'Óptima';
  if (gsm >= 4) return 'Buena';
  if (gsm >= 3) return 'Media';
  if (gsm >= 1) return 'Baja';

  return 'Sin señal';
}

function formatGpsSignal(value) {
  const sat = Number(value);

  if (Number.isNaN(sat)) return 'Sin datos';
  if (sat >= 8) return 'Óptima';
  if (sat >= 5) return 'Buena';
  if (sat >= 3) return 'Media';
  if (sat >= 1) return 'Baja';

  return 'Sin señal';
}

function formatKilometraje(value) {
  const odometer = Number(value);

  if (Number.isNaN(odometer)) return 'Sin datos';

const km = odometer / 1000;

  return `${km.toFixed(1)} km`;
}

export default VehicleDetail;
